module.exports = __webpack_public_path__ + "img/intercom.3dec8db0.svg";